<select
  class="form-control"
  [ngClass]="{ 'is-invalid': selectedYear.invalid && selectedYear.touched }"
  [formControl]="selectedYear"
>
  <option *ngFor="let year of years" [ngValue]="year">{{ year }}</option>
</select>
